import clsx from "clsx";
import { Tooltip } from "flowbite-react";
import React from "react";

interface ButtonToggleGroupProps {
  currentIndex: number;
  setIndex: (index: number) => void;
  indexes: {
    label: string;
    tooltip: string;
    disabled?: boolean;
  }[];
  className?: string;
}

const ButtonToggleGroup: React.FC<ButtonToggleGroupProps> = ({
  currentIndex,
  setIndex,
  indexes,
  className,
}) => {
  return (
    <div className={clsx("[&>div]:inline", "text-center", className)}>
      {indexes.map((index, i) => {
        const comp = (
          <button
            key={index.label}
            className={clsx(
              "py-2",
              "px-4",
              "border",
              "-skew-x-12",
              {
                "bg-button_primary text-button_text_primary border-button_primary hover:bg-button_primary/75":
                  currentIndex === i,
              },
              {
                "bg-gray-300 border-gray-500 dark:bg-gray-800 hover:bg-gray-500":
                  currentIndex !== i,
              },
              {
                "bg-gray-100 dark:bg-gray-900 cursor-not-allowed text-gray-500 hover:br-gray-100 dark:hover:bg-gray-900":
                  index.disabled,
              },
              { "rounded-l-xl border-r-0": i === 0 },
              { "rounded-r-xl border-l-0": i === indexes.length - 1 }
            )}
            disabled={index.disabled}
            onClick={() => setIndex(i)}
          >
            <div className={clsx("skew-x-12")}>{index.label}</div>
          </button>
        );

        if (!index.tooltip) {
          return comp;
        }

        return (
          <Tooltip content={index.tooltip} key={index.label}>
            {comp}
          </Tooltip>
        );
      })}
    </div>
  );
};

export default ButtonToggleGroup;
